var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckPurpleCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106 53C106 82.2711 82.2711 106 53 106C23.7289 106 0 82.2711 0 53C0 23.7289 23.7289 0 53 0C82.2711 0 106 23.7289 106 53Z",
    fill: "url(#paint0_linear_16000_3426)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4995 57.8182L40.6328 70.6667L79.4995 35.3333",
    stroke: "white",
    strokeWidth: 9
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16000_3426",
    x1: 0,
    y1: 0,
    x2: 106,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#C79EF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#863CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPurpleCircle);
export default __webpack_public_path__ + "static/media/check_purple_circle.cf92a5da87d7f344412e36542cb792d6.svg";
export { ForwardRef as ReactComponent };